import { memo, useMemo } from 'react';

import { AssetVersionSkeleton } from '~/components/v2/components/asset-modal/desktop/versions/asset-version-skeleton/AssetVersionSkeleton';
import { AssetVersionSkeletonInfo } from '~/components/v2/components/asset-modal/desktop/versions/asset-version-skeleton/AssetVersionSkeletonInfo';
import { AssetVersionSkeletonThumbnail } from '~/components/v2/components/asset-modal/desktop/versions/asset-version-skeleton/AssetVersionSkeletonThumbnail';
import { VersionsList } from '~/components/v2/components/asset-modal/desktop/versions/list/VersionsList';
import { VersionsListHeader } from '~/components/v2/components/asset-modal/desktop/versions/list/VersionsListHeader';
import { PublicVersionsListItem } from '~/components/v2/components/asset-modal/desktop/versions/PublicVersionsListItem';
import { usePublicVersionsList } from '~/swr-hooks/versions/usePublicVersionsList';

export const PublicVersionsList = memo(() => {
  const { data: versionsList, isLoading } = usePublicVersionsList();

  const versions = useMemo(() => {
    return versionsList?.data?.clips;
  }, [versionsList?.data?.clips]);

  const currentVersion = useMemo(() => {
    return versions?.find((version) => version.isDefault);
  }, [versions]);

  const otherVersions = useMemo(() => {
    return versions?.filter((version) => !version.isDefault);
  }, [versions]);

  return (
    <VersionsList>
      <VersionsListHeader title="Current" />
      {!isLoading && versions?.length ? (
        <div className="flex flex-col gap-2">
          {currentVersion && <PublicVersionsListItem version={currentVersion} />}

          {otherVersions?.length ? (
            <div className="flex flex-col gap-2">
              <VersionsListHeader title="Other" />
              <div className="flex flex-col gap-2">
                {otherVersions.map((version) => {
                  return <PublicVersionsListItem key={version.id} version={version} />;
                })}
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <AssetVersionSkeleton>
          <AssetVersionSkeletonThumbnail />
          <AssetVersionSkeletonInfo />
        </AssetVersionSkeleton>
      )}
    </VersionsList>
  );
});

PublicVersionsList.displayName = 'PublicVersionsList';
